export const DISCOUNT_VALIDATE_REQUEST = "DISCOUNT_VALIDATE_REQUEST";
export const DISCOUNT_VALIDATE_SUCCESS = "DISCOUNT_VALIDATE_SUCCESS";
export const DISCOUNT_VALIDATE_FAIL    = "DISCOUNT_VALIDATE_FAIL";
export const DISCOUNT_VALIDATE_RESET   = "DISCOUNT_VALIDATE_RESET";